import { render, staticRenderFns } from "./AppendixTop.vue?vue&type=template&id=3860b9ee&scoped=true"
import script from "./AppendixTop.vue?vue&type=script&lang=js"
export * from "./AppendixTop.vue?vue&type=script&lang=js"
import style0 from "./AppendixTop.vue?vue&type=style&index=0&id=3860b9ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3860b9ee",
  null
  
)

export default component.exports